<template >  
<div >
  <el-row class="table-grid-content">
			<el-col :span="3" >
				<el-input v-model="selecttypeName" placeholder="请输入搜索内容"></el-input>
			</el-col>
			<el-col :span="3" class="grid" :gutter="1" style="margin-left: 1rem;">
				<el-button type="success" @click="selectinit" icon="el-icon-search">搜索</el-button>
			</el-col>
			<el-col :span="2" class="grid" :gutter="15" style="margin-left: -2rem">
				<el-button type="primary" @click="addParamete()">增加</el-button>
			</el-col>
		</el-row>

  <el-table :data="parameterData" border style="width: 100%;margin-top: 1rem;">
    <el-table-column prop="id" label="id" v-if="show"></el-table-column>
    <el-table-column prop="roleName" label="角色名"></el-table-column>   
     
    <el-table-column label="操作">
    <template slot-scope="scope">
      <el-button type="primary" size="small" @click="jurisdiction(scope.row)">权限</el-button>
      <el-button type="primary" size="small" @click="parameterEdit(scope.$index, scope.row)">编辑</el-button>
      <el-button type="danger" size="small" @click="parameterDelete(scope.row)">删除</el-button>    
    </template>
  </el-table-column>
 </el-table>


  <el-pagination
    @size-change="sizeChange"
    @current-change="currentChange"
    :page-sizes="[10]"   
    :page-size="page.pageSize"
    layout="total, sizes, prev, pager, next"
    :total="page.totalRecords">
  </el-pagination>
  

<!--新增-->
  <el-dialog title="新增角色" :visible="addParameteForm" size="tiny" :modal-append-to-body='false' @close='closeDialog'>
  <el-form id="#addsForm" ref="addsForm" :model="addsForm" label-width="150px">
    <el-form-item label="角色名" prop="roleName">
      <el-input  v-model="addsForm.roleName" max-length="10"></el-input>
    </el-form-item> 
   
    <el-form-item>
      <el-button type="primary" @click="studentAdd()">确定</el-button>
      <el-button @click="addParameteForm = false;">取消</el-button>
    </el-form-item>
  </el-form>
</el-dialog>

<!--修改-->
  <el-dialog title="修改角色" :visible="editParameteForm" size="tiny" :modal-append-to-body='false' @close='closeDialog'>
  <el-form id="#editsForm" ref="editsForm" :model="editsForm" label-width="150px">
    
      <el-input  v-model="editsForm.id" v-if="value"></el-input>
    
    <el-form-item label="角色名" prop="roleName">
      <el-input  v-model="editsForm.roleName" max-length="10"></el-input>
    </el-form-item>
    
    <el-form-item>
      <el-button type="primary" @click="studentEdit()">确定</el-button>
      <el-button @click="editParameteForm = false;">取消</el-button>
    </el-form-item>
  </el-form>
</el-dialog>


<!--权限树-->
  <el-dialog title="权限管理" :visible="jurisdictionForm" size="tiny" :modal-append-to-body='false' @close='closeDialog'>
      <el-tree  ref="tree" 
         :data="treeData"
         show-checkbox
         node-key="id"         
         :default-checked-keys="treeSelected"  
        :default-expand-all="true"       
         >
</el-tree>
  <el-form id="#ujurisdictionForm" ref="ujurisdictionForm" :model="ujurisdictionForm" label-width="150px">
    <el-input  v-model="ujurisdictionForm.id" v-if="value"></el-input>
    <el-input  v-model="ujurisdictionForm.jurisdictions" v-if="value"></el-input>
    
    <el-form-item>
      <el-button type="primary" @click="jurisdictionAdd()">确定</el-button>
      <el-button @click="jurisdictionForm = false;">取消</el-button>
    </el-form-item>
  </el-form>
</el-dialog>
</div>
</template>

<script>
export default {
  data(){
    return{
      show:false,
      value: false,
      addParameteForm:false,
      editParameteForm:false,
      jurisdictionForm:false,
      ujurisdictionForm:{
          jurisdictions:[],
          jurisdictioned:[],
          id:''
      },
      parameterData:[],
      treeData:[],
      treeSelected:[],
      selecttypeName:"",
      page:{
        pageSize: 100, //每页条数,  默认10条
        totalRecords: 0, //总条数
        totalPages: 0, //总页数
        pageNum:0
      },     
        addsForm:{
  
          roleName:''
        } 
         ,
        editsForm:{
          id:'',
          roleName:''
        },
        apiUrl:''          
     
    }
  },
created(){
 this.apiUrl = localStorage.aipUrl
},
  mounted(){
    this.init();
      },
  methods:{
     selectinit(){
      this.page.pageNum=0;
      this.init();
    },   
    init(){
      this.parameterData=[];
      let {pageNum,pageSize}=this.page;
      this.axios({
          method:'post',         
          url:`${this.apiUrl}/manageRole/manageRoleFind?`+(new Date()).valueOf(),
          data: {
            pageNum: this.page.pageNum,
            roleName: this.selecttypeName,
            pageSize: this.page.pageSize

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){
            this.page.totalRecords=res.data.data.totalRecords; //总条数
            const studentArray=res.data.data.list;
            this.parameterData=studentArray;
          }
          if(res.data.stateCode==403){
            alert("您没有相应操作权限，请联系系统管理员！");
          }
      }).catch(error=>{
          
      })
    

    },
    // 每页显示多少条数据
sizeChange(val) {
  this.page.pageSize = val;
  this.init();
},
//翻页
currentChange(val) {
  this.page.pageNum=val-1;
  console.log(this.page.pageNum);
  this.init();
},
// 点击模态框关闭按钮关闭模态框
closeDialog(){
  this.addParameteForm = false;
  this.editParameteForm = false;
  this.jurisdictionForm = false;
},
// 点击新增按钮
addParamete(){
  this.addsForm={};
    this.addParameteForm = true;   //原来隐藏的新增信息模态框显示
},
//确定
 studentAdd(){
    let parameteList=this.addsForm;  
    let {roleName} = parameteList;
//判断数据是否为空
    if(roleName==''){
      this.$message.error('角色不准为空')
    }else{
//每一条都不为空时才向后台发送http请求
       this.axios({
          method:'post',         
          url:`${this.apiUrl}/manageRole/manageRoleAdd?`+(new Date()).valueOf(),
          data: {
            roleName: this.addsForm.roleName

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){
             this.$set(this.addsForm,{});
             console.log(this.addsForm);
             this.init();   //重新渲染数据列表
             this.addParameteForm = false;
              this.$message({
          message: res.data.msg,
          type: 'success'
        });
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
      }).catch(error=>{
          
      })

     
    }
},
//权限树
jurisdiction(row){
    this.ujurisdictionForm.id=row.id;
    this.axios({
          method:'post',         
          url:`${this.apiUrl}/manageRole/jurisdictionFind?`+(new Date()).valueOf(),
          data: {
            
            roleId: row.id

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){
              console.log("res",res);
                this.treeData=res.data.data.data;
                this.treeSelected=res.data.data.selected;
                this.jurisdictionForm = true;
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
      }).catch(error=>{
          
      })
},

jurisdictionAdd(){
    this.ujurisdictionForm.jurisdictions=this.$refs.tree.getHalfCheckedKeys();
    this.ujurisdictionForm.jurisdictioned=this.$refs.tree.getCheckedKeys();
     this.axios({
          method:'post',         
          url:`${this.apiUrl}/manageRole/updateJurisdiction?`+(new Date()).valueOf(),
          data: {
            roleId:this.ujurisdictionForm.id,
            jurisdictions: this.ujurisdictionForm.jurisdictions,
            jurisdictioned:this.ujurisdictionForm.jurisdictioned

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){           
             
             this.jurisdictionForm = false;
              this.$message({
          message: res.data.msg,
          type: 'success'
        });
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
      }).catch(error=>{
          
      })

},

// 点击修改修改按钮
parameterEdit(index,row){
    this.editParameteForm = true; //编辑信息模态框显示
    this.editsForm = Object.assign({}, row);  //获得所有数据显示在编辑信息模态框里面
},
//修改确定
 studentEdit(){
    let parameteList=this.editsForm;  
    let {roleName} = parameteList;
//判断数据是否为空
    if(roleName==''){
      this.$message.error('角色名不准为空')
    }else{
//每一条都不为空时才向后台发送http请求
       this.axios({
          method:'post',         
          url:`${this.apiUrl}/manageRole/manageRoleUpdate?`+(new Date()).valueOf(),
          data: {
            id:this.editsForm.id,
            roleName: this.editsForm.roleName

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){            
             this.init();   //重新渲染数据列表
             this.editParameteForm = false;
              this.$message({
          message: res.data.msg,
          type: 'success'
        });
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
      }).catch(error=>{
          
      })

     
    }
},
parameterDelete(row){
  this.$confirm('此操作将删除角色 ' + row.roleName + ', 是否继续?', '提示', { type: 'warning' })
    .then(() => { // 向服务端请求删除
      this.axios({
          method:'post',         
          url:`${this.apiUrl}/manageRole/manageRoleDel?`+(new Date()).valueOf(),
          data: {
            id:row.id,       

          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': sessionStorage.getItem("token")
          }
      }).then(res=>{                  
          if(res.data.stateCode==200){ 
                       
             this.init();   //重新渲染数据列表 
              this.$message({
          message: res.data.msg,
          type: 'success'
        });            
          }else if(res.data.stateCode==403){
            this.$message.error("您没有相应操作权限，请联系系统管理员！");
          }else{
            this.$message.error(res.data.msg);
          }
      }).catch(error=>{
          
      })
    }) .catch(() => {
    this.$message.info('已取消操作!');
  });
}
  }
}
</script>
<style scoped>

.el-table /deep/ th{
    background-color: #EEEFF1;
}

</style>


// WEBPACK FOOTER //
// src/views/roleList.vue